import { AnimatePresence } from "motion/react";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import * as motion from "motion/react-client";
import useScreenDimensions from "../hooks/useScreenDimensions";
import { isIOS } from "react-device-detect";
import { StandardButton } from "./standardButton";
import posthog from "posthog-js";

export const PermissionModal = ({
  cameraState,
  microphoneState,
  iosDoubleCheck,
  setIosDoubleCheck,
}: {
  cameraState: string;
  microphoneState: string;
  iosDoubleCheck: boolean;
  setIosDoubleCheck: (newVal: boolean) => void;
}) => {
  const isOpen = useMemo(() => {
    if (iosDoubleCheck) {
      return false
    } else if (!(cameraState === 'granted') || !(microphoneState === 'granted')) {
      return true
    } else {
      return false
    }
  }, [cameraState, microphoneState, iosDoubleCheck]);
  const { width, height } = useScreenDimensions();

  const cancelEvent = (e: React.MouseEvent) => e.stopPropagation();

  const closeModal = () => {};

  const missingPermissionString = useMemo(() => {
    if (cameraState !== "granted" && microphoneState !== "granted") {
      return "camera and microphone";
    } else if (cameraState !== "granted") {
      return "camera";
    } else {
      return "microphone";
    }
  }, [cameraState, microphoneState]);

  const [faileed, setFailed] = useState<boolean>(false);

  const iosGetMediaFromClick = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });
      if (stream) {
        setIosDoubleCheck(true);
      }
    } catch (e) {
      setFailed(true);
    }
  }, [navigator]);

  useEffect(() => {
    if (faileed) {
      posthog.capture("Failed to get permissions");
    }
  }, [faileed]);

  return (
    <AnimatePresence>
      {isOpen ? (
        <motion.div
          key={"campaignModal"}
          style={{
            width,
            height,
            backgroundColor: "rgba(0, 0, 0, .3)",
            position: "fixed",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
          }}
          onClick={closeModal}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
        >
          <div
            onClick={cancelEvent}
            style={{
              width: "40rem",
              minWidth: 400,
              backgroundColor: "white",
              padding: 24,
              borderRadius: 16,
              opacity: 1,
            }}
          >
            {!faileed ? (
              <>
                <div style={{ fontSize: "2rem", fontWeight: 500 }}>
                  Hold on there
                </div>
                <div>{`You still need to give us access to your ${missingPermissionString}`}</div>
                {true ? (
                  <StandardButton
                    buttonText="Grant Permission"
                    onClick={iosGetMediaFromClick}
                  />
                ) : null}
              </>
            ) : (
              <>
                <div style={{ fontSize: "2rem", fontWeight: 500 }}>
                  This is embarrassing
                </div>
                <div>{`We can't access your camera. This can usually be solved by granting permission in your browser or operating system settings`}</div>
              </>
            )}
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
